
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import ProtectedRoute from "./routing/ProtectedRoute";

const Layout: React.FC = () => {
  const location = useLocation();
  
  // Generate page title based on current path
  const getPageTitle = () => {
    const path = location.pathname.split('/').pop() || '';
    
    const titles: Record<string, string> = {
      '': 'Dashboard',
      'dashboard': 'Dashboard',
      'staff': 'Staff Management',
      'plans': 'Subscription Plans',
      'integrations': 'Integrations',
      'settings': 'Settings',
      'activities': 'Activity History',
      'hiring': 'Hiring Process'
    };
    
    return titles[path] || 'Dashboard';
  };
  
  return (
    <ProtectedRoute>
      <MainLayout title={getPageTitle()}>
        <div className="w-full p-4 md:p-6 lg:p-8 overflow-auto">
          <Outlet />
        </div>
      </MainLayout>
    </ProtectedRoute>
  );
};

export default Layout;
